import { useState } from "react";

const validateNum = (val) => {
	if(Number.isInteger(val) && val >= 1) return true;
	if(typeof val === "string") return /^[1-9][0-9]*$/.test(val);
	return false;
}

function TimerControl({ value, onChange }){
	const [draft, setDraft] = useState(value ?? "");
	return (<div>
		<div>
			<span>Timer:</span>
			<b>{value === null ? "none" : `${value} seconds`}</b>
		</div>
		<div>
			<input value={draft} onChange={(e) => setDraft(e.target.value)} type="number" placeholder="Timer" min="1" step="1" style={{display: "inline-block", width: "100px"}}/>
			<button onClick={()=>{
				if(validateNum(draft)){
					onChange(parseInt(draft));
				}
			}} disabled={draft==value} type="button">Use time</button>
			{value !== null && <button onClick={()=>onChange(null)} type="button">Remove</button>}
		</div>
	</div>);
}

export default TimerControl;